module.exports = __webpack_public_path__ + "static/img/image_we_07_02.4a19ce6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/home/image_we_07_02.png
// module id = jpeP
// module chunks = 10